// test1706
(1706 && 0);
